var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-rect',{ref:"arcFaceFour",attrs:{"config":_vm.config},on:{"click":_vm.onClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }